export function getAPIUrl() {
  const str: string = import.meta.env.VITE_API_URL;
  const lastChar = str.charAt(str.length - 1);
  return lastChar === '/' ? str : `${str}/`;
}
